﻿<main>
	<router-outlet>
	</router-outlet>
</main>
<eup-notification></eup-notification>
<eup-spinner></eup-spinner>
